<template>
    <div class="nav-search-panel">
        <!-- Search field menu -->
        <v-menu offset-y v-model="fieldOpen" :close-on-content-click="false" max-width="400">

            <template v-slot:activator="{ attrs, on }">
                <div class="nav-search-field" v-bind="attrs" v-on="on">
                    <span>{{ field.name }}</span>
                    <i class="fas fa-caret-down" :class="{'nav-search-field-open':fieldOpen}"></i>
                </div>
            </template>

            <div class="white pb-3 pt-3" v-if="fields && fields.length === 1">
                <v-list-item
                    class="pa-0  pt-1 pb-1"
                    v-for="fld in fields[0].fields"
                    :key="fld.id"
                    link
                    @click="onFieldSelected(fields[0].id, fld)"
                >
                    <v-list-item-title class="pl-3"  v-text="fld.name"></v-list-item-title>
                </v-list-item>
            </div>
        </v-menu>
        <!-- Search field menu -->

        <!-- Search criteria input -->
        <div class="nav-search-input">
            <label>
                <input @keypress.enter="onEnter" @focusin="onFocusIn" @focusout="onFocusOut" type="text" v-model="criteria" />
            </label>
            <div class="nav-search-icon">
                <a @click="onSearch"><i class="fas fa-search"></i></a>
            </div>
        </div>
        <!-- Search criteria input -->
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";

const Const = {
    search: {
        minLength: 1,
    },
}

export default {
    name: "MSiteSearch",

    props: {
        categories: {
            required: false,
            type    : Array,
            default : function () {
                return null;
            }
        },

        searchOnFocus: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        fieldOpen: false,
        inSearch : false,
        criteria : "",
        category : null,
        field    : {},
        timeoutHandle: null,
    }),

    watch: {
        criteria: function () {
            clearTimeout(this.timeoutHandle)
            this.timeoutHandle = setTimeout (() => {
                this.search();
            }, 1000)
        }
    },

    created: function () {
        this.init();
    },

    computed: {
        liftmanager() {
            return Core.role.liftmanager();
        },

        fields() {
            const fields = this.$store.getters.fields;
            if (fields instanceof Array) {
                return fields.filter (f => f.id === 'site');
            }

            return null;
        },
    },

    methods: {
        i18n(resource) {
            return this.$vuetify.lang.t("$vuetify.navtop.search." + resource);
        },

        async init () {
            await this.$store.dispatch('getFields');
            const searchFields = this.fields;
            if (searchFields.length === 0) {
                return;
            }

            const [category] = searchFields;
            [this.field] = category.fields;
            this.category = category.id;
        },

         onFieldSelected: function (category, field) {
            this.category = category;
            this.field    = field;
            if (this.criteria.length >= Const.search.minLength) {
                this.onSearch();
            }

            this.fieldOpen = false;
        },

        onFocusIn () {
            if (this.searchOnFocus) {
                if (!this.criteria || this.criteria.length === 0) {
                    this.criteria = "*";
                    this.onSearch()
                }
            }

            this.inSearch = true;
        },

        onFocusOut () {
            this.inSearch = false;
        },

        onEnter: function () {
            this.onSearch();
        },

        onSearch: function () {
            clearTimeout(this.timeoutHandle)
            this.search();
        },

        search () {
            this.$emit ("search", {
                field    : this.field.id,
                criteria : this.criteria,
            });
        }
    }
}

</script>

<style scoped>

::v-deep .v-sheet.v-list {
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 10px;
}

::v-deep .v-list-item {
    min-height: 36px;
    padding: 0 5px;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: black!important;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: white!important;
    border-radius: .125rem;
    -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
    -webkit-transition: all 0.1s linear;
    transition: all 0.1s linear;
}

::v-deep .v-list-item__title {
    font-size: 11pt;
}

.nav-search-hit-panel {
    width: 125px;
    height: 32px;
    font-size: 12pt;
    padding-top: 4px;
    padding-left: 10px;
    margin-left: 10px;
    border-radius: 4px;
    text-align: center;
}

.nav-field-category {
    min-height: 36px;
    background-color: lightsteelblue;
}

.nav-field-category-title {
    font-size: 11pt;
    font-weight: 400;
    color: white!important;
}

.nav-search-panel {
    display: flex;
    height: 35px;
}

.nav-search-input,
.nav-search-field{
    background-color: white;
    color: black;
    border-style: solid;
    border-color: lightgray;
    border-width: 1px;
    border-radius: 2px;
    letter-spacing: normal;
    font-size: 11pt!important;
    line-height: 1.5;
    margin-right: 10px;
    padding-left: 10px;
    padding-top: 3px;
    height: 32px;
    width: 180pt;
    text-align: left;
    padding-top: 5px;
}

.nav-search-field i {
    float: right;
    padding-right: 10px!important;
}

.nav-search-field-open  {
    transform: rotate(180deg) translate(10px);
    -webkit-transition: all 150ms ease-in 0s;
    transition: all 150ms ease-in 0s;
}

.nav-search-input input {
    outline: none;
    width: 100%;
}

::v-deep .v-btn__content {
    align-items: start;
}

::v-deep .v-menu__content {
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
    min-width: 16rem !important;
}

.nav-search-icon {
    position: relative;
    top: -23px;
    left: 207px;
    width: 20px
}

.nav-search-icon i {
    color: gray;
    font-size: 11pt!important;
}

::v-deep .v-expansion-panel-content__wrap {
    padding: 0;
    padding-bottom: 10px;
}

::v-deep .v-expansion-panel-header {
    padding: 15px;
}

</style>